import { StyleSheet } from 'react-native';
// import CountryFlag from "react-native-country-flag";     // issue with mobile. left here for future use
import Flag from 'react-native-flags';
import axios from 'axios';

// * Use library to get countries (not needed currently)
// var countries = require("i18n-iso-countries");
// countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
// countries.registerLocale(require("i18n-iso-countries/langs/el.json"));

const CountriesWithFlagsList = async (language, colors, username, user, clientApi) => {

    const styles = makeStyles(colors);
    const countriesFlags = [];

    try {
        const response = await axios.get(`${clientApi}api/GenParams/Countries`, {
            headers: { Authorization: `Bearer ${user.token}` },
            params: {
                username: username,
            }
        });
        // add country names with flags in array
        response.data.map((country) => {
            //* for translation (not needed currently)
            // countriesFlags.push({ 
            //     label: language === "gr" ? country.grCountry : country.country, value: country.isoCode, icon: () => <CountryFlag isoCode={country.isoCode} size={20} style={styles.icon} />
            // });
            countriesFlags.push({
                label: country.country,
                value: country.country,
                icon: () =>
                    <Flag
                        code={country.isoCode}
                        type="shiny"
                        size={24}
                    />
            });
            // TODO: show error message when flag cannot be found using ISOCode
        });
        // sort by asc order of country name
        countriesFlags.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        return countriesFlags;
    } catch (error) {
        console.error('error', error);
    };

};

const makeStyles = (colors) => StyleSheet.create({
    icon: {
        borderColor: colors.text_primary,
        borderWidth: 1,
    },
});

export default CountriesWithFlagsList;